import { call, put } from "redux-saga/effects";
import moment from "moment";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";
//import { ACTIONS, API_URL, STORAGE } from '../../_config'

//import { CallApi, responseHandler } from '../api/callApi';
//import { UpdateWithVariables } from '../../_common/functions';
// const API_BASE_URL = process.env.REACT_APP_API_URL;

export function* login(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.LOGIN, data);

        if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.success === true) {
            const userData = resp.data?.data;
            if (!userData?.locations || userData.locations.length === 0) {
                action && action.callbackError && action.callbackError(
                    "Your account is not assigned to any location. Please contact your administrator."
                );
                return;
            }

            const refreshTokenExpiryTime = moment.utc(userData.refreshTokenExpiryUtc).local().toISOString();

            localStorage.setItem(STORAGE, JSON.stringify(userData));
            localStorage.setItem(KEYS.AUTH_ACCESS, userData.token);
            localStorage.setItem(KEYS.AUTH_REFRESH, userData.refreshToken);
            localStorage.setItem(KEYS.REFRESH_TOKEN_EXPIRY, refreshTokenExpiryTime);

            yield put({
                type: ACTIONS.USER.LOGIN,
                payload: {
                    user: userData,
                    accessToken: userData.token,
                    refreshToken: userData.refreshToken,
                    refreshTokenExpiryTime,
                    isAuthenticated: true,
                    permissions: true,
                },
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
            // action && action.callbackError && action.callbackError(resp.data?.errorMessage || "Invalid login credentials");
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e?.data?.errorMessage || e?.data || e);
    }
}
export function* register(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.REGISTRATION, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* forgotPassword(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.FORGOT_PASSWORD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* resetPassword(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.RESET_PASSWORD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getDesigns(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.GET_DESIGNS, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* saveDesign(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_DESIGN, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* updateDesign(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.UPDATE_DESIGN, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getImages(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.IMAGE_LIST, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* uploadImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.IMAGE_UPLOAD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.IMAGE_DELETE, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* logout(action: any): any {
    try {
        // Call the logout API first
        const resp = yield call(CallApi.POST, APIS.AUTH.LOGOUT, {});

        // Clear local storage regardless of API response
        localStorage.removeItem("persist:root");
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(KEYS.AUTH_ACCESS);
        localStorage.removeItem(KEYS.AUTH_REFRESH);
        localStorage.removeItem(KEYS.REFRESH_TOKEN_EXPIRY);

        yield put({
            type: ACTIONS.USER.LOGOUT,
            payload: {},
        });
        
        // Call success callback with API response or empty object
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackSuccess && action.callbackSuccess({});
        }
    } catch (e: any) {
        // Even if API fails, still clear local storage and logout locally
        localStorage.removeItem("persist:root");
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(KEYS.AUTH_ACCESS);
        localStorage.removeItem(KEYS.AUTH_REFRESH);
        localStorage.removeItem(KEYS.REFRESH_TOKEN_EXPIRY);

        yield put({
            type: ACTIONS.USER.LOGOUT,
            payload: {},
        });
        
        // Call success callback even on API error since we want to logout locally
        action && action.callbackSuccess && action.callbackSuccess({});
    }
}

export function* getMenus(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.USER.MENUS, action.payload, true);
        
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            const menuData = resp.data.data;
            
            // Transform menu data into permissions format
            const transformMenuToPermissions = (menuItems: any[]) => {
                const permissions: Record<string, Array<{ keyName: string; keyCode: string; permission: boolean }>> = {};
                
                const processMenuItems = (items: any[]) => {
                    items.forEach((menu) => {
                        if (menu.url && menu.url !== "N/A" && menu.url !== "#") {
                            permissions[menu.url] = [
                                {
                                    keyName: "READ",
                                    keyCode: "R",
                                    permission: menu.read || false,
                                },
                                {
                                    keyName: "WRITE",
                                    keyCode: "W",
                                    permission: menu.write || false,
                                },
                                {
                                    keyName: "DELETE",
                                    keyCode: "D",
                                    permission: menu.delete || false,
                                },
                            ];

                            // For now using all permissions as true
                            // permissions[menu.url] = [
                            //     {
                            //         keyName: "READ",
                            //         keyCode: "R",
                            //         permission: true,
                            //     },
                            //     {
                            //         keyName: "WRITE",
                            //         keyCode: "W",
                            //         permission: true,
                            //     },
                            //     {
                            //         keyName: "DELETE",
                            //         keyCode: "D",
                            //         permission: true,
                            //     },
                            // ];
                        }
                        
                        // Process submenus recursively
                        if (menu.submenu && menu.submenu.length > 0) {
                            processMenuItems(menu.submenu);
                        }
                    });
                };
                
                processMenuItems(menuItems);
                return permissions;
            };
            
            const permissions = transformMenuToPermissions(menuData);
            
            // Dispatch both menus and permissions automatically
            yield put({
                type: ACTIONS.USER.MENUS,
                payload: menuData,
            });
            
            yield put({
                type: ACTIONS.USER.MENU_PERMISSIONS,
                payload: permissions,
            });
            
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.errorMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getUserActivity(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.USER.GET_USER_ACTIVITY,
        action.payload,
        true
    );
}

export function* getLastPunchStatus(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.USER.LAST_PUNCH_STATUS, action.payload, true);
}

export function* clockIn(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER.CLOCK_IN, action.payload, true);
}
